// extracted by mini-css-extract-plugin
export default {"this":"Head_this__4e15U","bar":"Head_bar__oTcyq","title":"Head_title__TtvxP"};